import Strings from '../../../translations/strings';
import { getBaseUrl } from '../../../api/legacyApi';
import windowsImg from '../../../img/icons-eway/windows.svg'
import mobileImg from '../../../img/icons-eway/phone-01.svg'
import appleLogoIcon from '../../../img/icons-vendors/icons-apple-logo.svg'
import androidLogoIcon from '../../../img/icons-vendors/icons-android-os.svg'
import adminImg from '../../../img/icons-eway/admin-01.svg'
import supportImg from '../../../img/icons-eway/support-01.svg'
import styles from './CardContainer.module.css';
import platform from 'platform';
import appleChromeImg from '../../../img/icons-browsers/apple_chrome.svg';
import appleEdgeImg from '../../../img/icons-browsers/apple_edge.svg';
import appleFirefoxImg from '../../../img/icons-browsers/apple_firefox.svg';
import appleOperaImg from '../../../img/icons-browsers/apple_opera.svg';
import appleSafariImg from '../../../img/icons-browsers/apple_safari.svg';
import chromeImg from '../../../img/icons-browsers/chrome.svg';
import edgeImg from '../../../img/icons-browsers/edge.svg';
import firefoxImg from '../../../img/icons-browsers/firefox.svg';
import operaImg from '../../../img/icons-browsers/opera.svg';
import webImg from '../../../img/icons-browsers/web.svg';

export interface ICard {
    id: number;
    title: () => string;
    img: string;
    imgClassName?: string;
    link: (props: ICardLink) => string;
    btnText: () => string;
    btnOptions?: IbtnOptions[];
}

interface ICardLink {
    eWayVersion?: string;
}

export interface IbtnOptions {
    text: string;
    iconType?: string;
    icon?: string;
    link: () => string;
}

const getCorrectLinkDomain = () => {
    if (process.env.REACT_APP_ENV === 'testing' || process.env.NODE_ENV === 'development') {
        return '.dev';
    } else {
        return '.com';
    }
};

const correctDomain = getCorrectLinkDomain();
const currentUrl = getBaseUrl();

const APPLE_PLATFORMS = ["OS X", "iOS"]
const getO365Img = () => {
    if (APPLE_PLATFORMS.includes(platform.os?.family as string)) {
        if (platform.name?.includes("Chrome")) {
            return appleChromeImg;
        } else if (platform.name?.includes("Firefox")) {
            return appleFirefoxImg;
        } else if (platform.name?.includes("Edge")) {
            return appleEdgeImg;
        } else if (platform.name?.includes("Safari")) {
            return appleSafariImg;
        } else if (platform.name?.includes("Opera")) {
            return appleOperaImg;
        } else {
            return appleSafariImg;
        }
    }

    if (platform.name?.includes("Chrome")) {
        return chromeImg;
    } else if (platform.name?.includes("Firefox")) {
        return firefoxImg;
    } else if (platform.name?.includes("Edge")) {
        return edgeImg;
    } else if (platform.name?.includes("Safari")) {
        return appleSafariImg;
    } else if (platform.name?.includes("Opera")) {
        return operaImg;
    } else {
        return webImg;
    }
}

export const cards: ICard[] = [
    {
        id: 1,
        title: () => Strings.components.cards.titleOutlook,
        link: ({ eWayVersion }) =>
            eWayVersion ? `https://download.eway-crm${correctDomain}/setup/eWayCRM-${eWayVersion}.exe` : '',
        img: windowsImg,
        imgClassName: styles.windowsIcon,
        btnText: () => Strings.components.cards.btnOutlook,
    },
    {
        id: 2,
        title: () => Strings.components.cards.titleWeb,
        link: () => `${currentUrl}/Web`,
        img: getO365Img(),
        btnText: () => Strings.components.cards.btnWebInstall,
        btnOptions: [
            {
                text: Strings.components.cards.btnWebInstall,
                link: () => `https://eway.cr/365`,
            },
            {
                text: Strings.components.cards.btnWebLogIn,
                link: () => `${currentUrl}/Web`,
            },
        ],
    },
    {
        id: 3,
        title: () => Strings.components.cards.titleMobile,
        link: () => '',
        img: mobileImg,
        btnText: () => Strings.components.cards.btnMobile,
        btnOptions: [
            {
                text: 'iOS',
                iconType: 'svg',
                icon: appleLogoIcon,
                link: () => 'https://apps.apple.com/us/app/eway-crm/id1129888734',
            },
            {
                text: 'Android',
                iconType: 'svg',
                icon: androidLogoIcon,
                link: () => 'https://play.google.com/store/apps/details?id=com.eway_crm.mobile.androidapp',
            },
        ],
    },
    {
        id: 5,
        title: () => Strings.components.cards.titleAdminCenter,
        link: () => `${currentUrl}/admin`,
        img: adminImg,
        btnText: () => Strings.components.cards.btnAdmin,
    },
    {
        id: 6,
        title: () => Strings.components.cards.titleContactSupport,
        link: ({ eWayVersion }) => `${Strings.components.cards.linkSupport}`,
        img: supportImg,
        btnText: () => Strings.components.cards.btnHelpdesk,
    },
];
